import { Component } from '@theme/component';

/**
 * A custom element that navigates to the previous page in the browser history.
 *
 * Hides itself when there is no previous page to return to, so the
 * button never renders as a dead no-op action.
 *
 * @extends Component
 */
export class BackButtonComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    // if (!(document.referrer && history.length > 1)) {
    //   this.hidden = true;
    // }
  }

  /**
   * Navigates back to the previous page.
   *
   * @param {Event} event
   */
  back(event) {
    event.preventDefault();
    history.back();
  }
}

if (!customElements.get('back-button-component')) {
  customElements.define('back-button-component', BackButtonComponent);
}
